var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uploader-box"},[_c('van-uploader',{attrs:{"max-count":1,"max-size":_vm.uploaderMaxSize.imageMaxSize * 1024,"after-read":_vm.afterRead},on:{"oversize":_vm._onOversize}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }